"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalTimeZoneString = exports.renderLocalTimestamps = exports.formatTimestamp = void 0;
function formatTimestamp(ts, opts) {
    if (opts === void 0) { opts = {}; }
    var ms = normaliseEpoch(ts);
    if (ms === null)
        return String(ts);
    var _a = opts.showTime, showTime = _a === void 0 ? true : _a, _b = opts.dateStyle, dateStyle = _b === void 0 ? "medium" : _b, _c = opts.timeStyle, timeStyle = _c === void 0 ? "short" : _c;
    var locale = navigator.language;
    var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var options = {
        timeZone: timeZone,
        dateStyle: dateStyle,
    };
    if (showTime) {
        options.timeStyle = timeStyle;
    }
    return new Intl.DateTimeFormat(locale, options).format(new Date(ms));
}
exports.formatTimestamp = formatTimestamp;
function renderLocalTimestamps(root, opts) {
    if (root === void 0) { root = document; }
    if (opts === void 0) { opts = {
        showTime: true,
        dateStyle: "medium",
        timeStyle: "short"
    }; }
    var counter = 0;
    root.querySelectorAll("[data-ts]").forEach(function (el) {
        var ts = Number(el.dataset.ts);
        if (!Number.isFinite(ts))
            return;
        el.textContent = formatTimestamp(ts, opts);
        counter++;
    });
    console.log("Rendered ".concat(counter, " local timestamps."));
}
exports.renderLocalTimestamps = renderLocalTimestamps;
// php uses seconds, js uses milliseconds - this function normalises both to ms
function normaliseEpoch(input) {
    var n = typeof input === "string" ? Number(input) : input;
    if (!Number.isFinite(n))
        return null;
    var abs = Math.abs(n);
    if (abs > 1e14) {
        // microseconds → convert to ms
        return Math.floor(n / 1000);
    }
    if (abs > 1e11) {
        // milliseconds
        return Math.floor(n);
    }
    // seconds
    return Math.floor(n * 1000);
}
function getLocalTimeZoneString(style) {
    var _a, _b;
    if (style === void 0) { style = "short"; }
    var locale = navigator.language;
    var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var parts = new Intl.DateTimeFormat(locale, {
        timeZone: timeZone,
        timeZoneName: style,
    }).formatToParts(new Date());
    return (_b = (_a = parts.find(function (p) { return p.type === "timeZoneName"; })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : timeZone;
}
exports.getLocalTimeZoneString = getLocalTimeZoneString;
